import { render, staticRenderFns } from "./localization-text-field.vue?vue&type=template&id=ddd3502a&scoped=true"
import script from "./localization-text-field.vue?vue&type=script&lang=js"
export * from "./localization-text-field.vue?vue&type=script&lang=js"
import style0 from "./localization-text-field.vue?vue&type=style&index=0&id=ddd3502a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd3502a",
  null
  
)

export default component.exports